var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('hero',{attrs:{"title":"Welcome to NLV Media Transcoder","sub-title":"To get started, either create a new job, or view your existing jobs below."}}),_c('div',{staticClass:"container is-max-widescreen p-4"},[_c('finished-footage'),_c('jobs-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }